import './src/styles/global.css';

const isAgentForceBotEnabled = process.env.GATSBY_AGENTFORCE_BOT === 'true';

function initEmbeddedMessaging() {
  try {
    if (!window.embeddedservice_bootstrap) return;
    window.embeddedservice_bootstrap.settings.language = 'en_US';

    window.embeddedservice_bootstrap.init(
      '00DWL000002YR4m',
      'LEAP_Brand_Website_Messaging_Setting_3',
      'https://nvs-leap--leapinnova.sandbox.my.site.com/ESWLEAPBrandWebsiteMes1769715888654',
      {
        scrt2URL: 'https://nvs-leap--leapinnova.sandbox.my.salesforce-scrt.com',
      }
    );
  } catch (error) {
    console.error('Error loading Embedded Messaging: ', error);
  }
}

function loadAgentForceBot() {
  if (!isAgentForceBotEnabled) return;
  if (typeof window === 'undefined') return;

  if (window.__embeddedMessagingLoaded) return;
  window.__embeddedMessagingLoaded = true;

  const script = Object.assign(document.createElement('script'), {
    id: 'embedded-messaging-bootstrap',
    type: 'text/javascript',
    src: 'https://nvs-leap--leapinnova.sandbox.my.site.com/ESWLEAPBrandWebsiteMes1769715888654/assets/js/bootstrap.min.js',
    onload: initEmbeddedMessaging,
    onerror: () => {
      console.error('Failed to load Embedded Messaging script');
    },
  });

  document.body.appendChild(script);
}

export const onInitialClientRender = () => {
  loadAgentForceBot();
};

export const onClientEntry = () => {
  const cookieBannerId = process.env.GATSBY_COOKIE_BANNER_ID;
  if (!cookieBannerId) return;

  const autoBlock = document.createElement('script');
  autoBlock.type = 'text/javascript';
  autoBlock.src = `https://cdn.cookielaw.org/consent/${cookieBannerId}/OtAutoBlock.js`;
  document.head.appendChild(autoBlock);

  const sdkStub = document.createElement('script');
  sdkStub.src = `https://cdn.cookielaw.org/consent/${cookieBannerId}/otSDKStub.js`;
  sdkStub.type = 'text/javascript';
  sdkStub.setAttribute('charset', 'UTF-8');
  sdkStub.setAttribute('data-domain-script', cookieBannerId);
  sdkStub.onerror = () => {
    console.warn('OneTrust otSDKStub.js failed to load. Cookie banner may not be available.');
  };
  document.head.appendChild(sdkStub);

  const wrapper = document.createElement('script');
  wrapper.type = 'text/javascript';
  wrapper.innerHTML = 'function OptanonWrapper() {}';
  document.head.appendChild(wrapper);
};
